
import { ReservationItemModule } from '@/store/modules/reservationItem';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PaymentInfoForm',
  components: {
  },
})
export default class extends Vue {
  get formData() {
    return ReservationItemModule.form;
  }

  private rules = {
    shopId: [
      { required: true, message: '가맹점 아이디를 입력하세요', trigger: 'blur' },
    ],
    shopKey: [
      { required: true, message: '가맹점 키를 입력하세요.', trigger: 'blur' },
    ],
    shopApiKey: [
      { required: true, message: '가맹점 API 키를 입력하세요.', trigger: 'blur' },
    ],
    shopApiIv: [
      { required: true, message: '가맹점 API IV를 입력하세요.', trigger: 'blur' },
    ],
  };
}
